
import Vue, { PropType } from "vue";
import { compareAsc, format } from "date-fns";
import { getDateFnsLocale } from "@/lib/utils/i18n/locale";
import { optimizeImage } from "@/lib/utils/url";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    contest: Object as PropType<Contest>,
  },
  computed: {
    id() {
      const { contest } = this;
      return contest.id;
    },
    title() {
      const { contest } = this;
      return contest.contest;
    },
    department() {
      const { contest } = this;
      return contest.department;
    },
    free() {
      const { contest } = this;
      return contest.free;
    },
    tag() {
      const { genre, category } = this;

      let tag = "";

      if (genre.length) {
        genre.forEach((x) => (tag += `#${x} `));
      }

      if (category.length) {
        category.forEach((x) => (tag += `#${x} `));
      }

      return tag;
    },
    image() {
      const { contest } = this;
      const { url } = contest.image;
      return url && optimizeImage(`${url}?fit=fill&fill=blur&w=600&h=315`);
    },
    deadline() {
      const { contest } = this;
      const { deadline } = contest;

      if (!deadline) return "-";

      const locale = getDateFnsLocale(this.$i18n.locale);
      const formatStr = this.$t("common.deadlineFormat") as string;
      return format(deadline, formatStr, { locale });
    },
    genre() {
      const { contest } = this;
      return contest.genre;
    },
    category() {
      const { contest } = this;
      return contest.category;
    },
    award() {
      const { contest } = this;
      return contest.award;
    },
    content() {
      const { contest } = this;
      return contest.content;
    },
    homepage() {
      const { contest } = this;
      return contest.homepage;
    },
    isClosed() {
      const { contest } = this;
      const currentDate = new Date();
      const contestDeadline = new Date(contest.deadline);
      return compareAsc(currentDate, contestDeadline) === 1;
    },
    status() {
      return this.isClosed ? this.$t("contestCard.status.closed") : this.$t("contestCard.status.open");
    },
  },
  methods: {
    onClickCard() {
      const { $router, id } = this;
      $router.push({ name: "eventContestDetail", params: { id } });
    },
  },
});

interface Props {
  contest: Contest;
}

interface Data {}

interface Computed {
  id: string;
  title: string;
  department: string;
  free: string;
  tag: string;
  image?: string;
  deadline: string;
  genre: string[];
  category: string[];
  award: string;
  content: string;
  homepage: string;
  isClosed: boolean;
  status: string;
}

interface Methods {
  onClickCard(): void;
}

type Contest = {
  [key: string]: any;
};
